// extracted by mini-css-extract-plugin
export default {"page":"pageGuides_page__PD7S4","intro":"pageGuides_intro__4S8M+","p":"pageGuides_p__cenU3","section":"pageGuides_section__25b+5","sectionHead":"pageGuides_sectionHead__AMFHE"};